import { Link } from "react-router-dom";
import { apiDomain } from "../../js/server";

const kind = {
  info: "공지사항",
  news: "자동차정비뉴스",
  event: "경조사",
  gallery: "포토갤러리",
  union_mem: "정비업체 현황",
};

function MainBoard(props) {
  const setList = () => {
    switch (props.kind) {
      case "info": //공지사항
      case "event": //경조사
        return (
          <div className="feature-item mb-3 mb-lg-0 col-12 main-board">
            <h4 className="mb-3 pl-0">
              <Link to={`/ABoardList?kind=${props.kind}`}>
                {kind[props.kind] || null}
              </Link>
            </h4>
            <ul className="w-hours list-unstyled">
              {props.items.length > 0
                ? props.items.map((item, idx) => (
                    <Link
                      to={`/ABoardView?bserial=${item.bserial}&page=1&keyword=&kind=${props.kind}`}
                      key={idx}
                    >
                      <li className="d-flex justify-content-between">
                        {item.subject.substring(0, 15) + "..." || ""}
                        <span>{item.wdate || ""}</span>
                      </li>
                    </Link>
                  ))
                : `등록된 ${kind[props.kind] || null}가(이) 없습니다.`}
            </ul>
          </div>
        );
      case "news": //자동차정비뉴스
        return (
          <div className="feature-item mb-3 mb-lg-0 col-12 main-board">
            <h4 className="mb-3 pl-0">
              <Link to={`/ABoardList?kind=${props.kind}`}>
                {kind[props.kind] || null}
              </Link>
            </h4>
            <ul className="w-hours list-unstyled">
              {props.items.length > 0
                ? props.items.map((item, idx) => (
                    <li
                      className="d-flex justify-content-between"
                      onClick={() => {
                        window.open(item.contents, "_blank");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {item.subject.substring(0, 15) + "..." || ""}
                      <span>{item.wdate || ""}</span>
                    </li>
                  ))
                : `등록된 ${kind[props.kind] || null}가(이) 없습니다.`}
            </ul>
          </div>
        );
      case "gallery": //포토갤러리
        return (
          <div
            className="feature-item mb-3 mb-lg-0 col-12 main-board"
            style={{ minHeight: "365px" }}
          >
            <h4 className="mb-3 pl-0">
              <Link to={`/ABoardList?kind=${props.kind}`}>
                {kind[props.kind] || null}
              </Link>
            </h4>

            <div className="row w-hours list-unstyled d-flex">
              {props.items.length > 0 ? (
                props.items.map((item, idx) => (
                  <div className="col-12 col-lg-4">
                    <Link
                      to={`/ABoardView?bserial=${item.bserial}&page=1&keyword=&kind=${props.kind}`}
                      key={idx}
                      className="flex-fill text-center d-flex flex-column align-items-center main-gallery-link"
                    >
                      <img
                        src={`${apiDomain}${item.file_dir}/${item.file_name}`}
                        alt=""
                        className="img-thumbnail img-cover img-fluid mb-2 main-gallery-img"
                      />
                      <span
                        className="text-truncate"
                        style={{ maxWidth: "90%" }}
                      >
                        {item.subject.substring(0, 15) + "..." || ""}
                      </span>
                      <span style={{ fontSize: "0.8rem" }}>
                        {item.wdate || ""}
                      </span>
                    </Link>
                  </div>
                ))
              ) : (
                <div className="flex-fill text-center col-12 col-lg-12">
                  등록된 {kind[props.kind] || null}가(이) 없습니다.
                </div>
              )}
              {Array(3 - props.items.length)
                .fill()
                .map((_, idx) => (
                  <li
                    key={props.items.length + idx}
                    className="flex-fill col-12 col-lg-4"
                  ></li>
                ))}
            </div>
          </div>
        );
      case "union_mem": //정비업체현황
        return (
          <div
            className="feature-item mb-3 mb-lg-0 col-12 main-board"
            style={{ height: "365px" }}
          >
            <h4 className="pl-0">
              <Link to={`/UnionMem`}>{kind[props.kind] || null}</Link>
            </h4>

            <div className="img-container">
              <Link to={`/UnionMem`}>
                <img
                  src="/images/gw_map_main01.png"
                  alt="정비업체현황"
                  className="img-fluid"
                />
                <img
                  src="/images/gw_map_main02.png"
                  alt="정비업체현황"
                  className="img-fluid fade-image"
                />
              </Link>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return <>{setList()}</>;
}

export default MainBoard;
